<app-datatable [identifier]="'execution-table'" (actionmenuevent)="actionMenuClicked($event)"
  [hidden]="detailState !== ActivitiesExecutionDetailsState.INIT"
  [cols]="cols" [rows]="deployments" [pagination]="true" [total]="total" [isloading]="loading"
  (pageevent)="onPageChange($event)" (rowclickevent)="activitiesRowClick($event)" [title]="title" [showfiltericon]="true" [filters]="deploymentsTableFilter"
[showremoveallicon]="showRemoveAllPlanActivities" (onclickheaderremoveall)="removeAllPlanActivities($event)"  [showSwitchEnv]="true" (onclickswitchenv)="onClickSwitchEnv()"></app-datatable>
<!DOCTYPE html>
<ng-template [ngTemplateOutlet]="deploymentDetailsRef"  [ngTemplateOutletContext]="{ deployments: deployments }"></ng-template>
<ng-template #deploymentDetailsRef let-deployments="deployments">
  @if (detailState == ActivitiesExecutionDetailsState.VIEW_DETAILS) {
    <div class="ot-panel" animate.enter="enter-animation">
      <div class="otsc-activities-detail-container">
        <div class="otsc-activities-detail-container_nav" style="border-right: 1px solid #d5d5d5;padding: 5px 20px 5px 15px">
          <div class="back-container">
            <button (click)="goBack()" aria-label="Back" i18n-title title="Back" class="otsc-btn__back ot-btn ot-btn--is-micro ot-btn--is-icon-btn">
              <div class="ot-icon ot-icon__action" id="otsc-activities-execution-detail__back_btn">
              </div>
            </button>
          </div>
          <div class="otsc-text__back" i18n>Execution Plans</div>
        </div>
        <div class="otsc-activities-detail-container_nav d-block" style="padding: 5px 20px 5px 15px">
          <div class="ot-level">
            <div class="ot-level__left">
              <div class="ot-level__item">
                <div class="otsc-ua-report-title" i18n>
                {{ currentDeploymentResult.executionPlanName + ' details'}}
              </div>
              </div>
            </div>
            <div class="ot-level__center">
              <div class="ot-level__item"></div>
            </div>
            <div class="ot-level__right">
              <div class="ot-level__item">
                <button class="ot-btn ot-btn--is-primary" title="View plan" i18n-title i18n (click)="viewPlan()">View plan</button>
              </div>
            </div>
          </div>
        </div>
        <div class="otsc-activities-detail-container_content" style="border-right: 1px solid #d5d5d5;">
          <ng-scrollbar>
            <ul id="activityExecutionList" class="ot-list" style="padding-top:8px; max-width: 258px;">
              @for (row of deployments; track row; let i = $index) {
                <li (click)="setCurrentDeploymentResult(row.data, true)" (keyup.enter)="setCurrentDeploymentResult(row.data, true)" [tabindex]="i == 0 ? 0 : -1"
                  class="ot-list__item" [ngClass]="{'otsc-activities-item_selected': row.data.deploymentId === currentDeploymentResult.deploymentId}"
                  (keydown)="onActivityListKeyDown($event, row, i)">
                  <div>
                    @if (row.data.executionStatus == 'COMPLETED') {
                      <i class="otsc-activity-status-icon otsc-icon-status-success"></i>
                    }
                    @if (row.data.executionStatus == 'RUNNING') {
                      <i class="otsc-activity-status-icon otsc-icon-status-loading-spinner"></i>
                    }
                    @if (row.data.executionStatus == 'ERROR') {
                      <i class="otsc-activity-status-icon otsc-icon-status-error"></i>
                    }
                    @if (row.data.executionStatus == 'CANCELED') {
                      <i class="otsc-activity-status-icon otsc-icon-status-cancelled"></i>
                    }
                    @if (row.data.executionStatus == 'QUEUED') {
                      <i class="otsc-activity-status-icon otsc-icon-status-waiting"></i>
                    }
                  </div>
                  <span [title]="row.data.executionPlanName">{{row.data.executionPlanName}}</span>
                </li>
              }
            </ul>
          </ng-scrollbar>
        </div>
        <div class="otsc-activities-item-container_content">
          <div class="ot-panel__header">
            <app-tabs [identifier]="'activity-execution-details-tabs'" (selected)="onSelectedDataTabChange($event)" [tabs]="activityExecutionTabs" [color]="TabColor.SECONDARY" [selectedIndex]="activePropertyTab"></app-tabs>
          </div>
          <div style="overflow: auto;height: 100vh;">
            <div>
              @if (activePropertyTab === ActivityExecutionPropertyTab.GENERAL) {
                <div id="otsc-activity-execution-general" class="otsc-activities-section">
                  <div class="otsc-activities-section-title ot-pl-3 ot-pr-3" i18n>General</div>
                  <div class="otsc-metadata ot-pt-1 ot-pb-1 ot-pl-4 ot-pr-2">
                    <div class="ot-row" data-activity-metadata-row="id">
                      <div class="ot-row__column otsc-metadata-key">
                        <small class="ot--has-text-muted" i18n>Id</small>
                      </div>
                      <div class="ot-row__column otsc-metadata-value">
                        <p>{{currentDeploymentResult.deploymentId}}</p>
                      </div>
                    </div>
                    <div class="ot-row" data-activity-metadata-row="created-by">
                      <div class="ot-row__column otsc-metadata-key">
                        <small class="ot--has-text-muted" i18n>Created by</small>
                      </div>
                      <div class="ot-row__column otsc-metadata-value">
                        <p>{{currentDeploymentResult.initiatorUserName}}</p>
                      </div>
                    </div>
                    <div class="ot-row" data-activity-metadata-row="created-date">
                      <div class="ot-row__column otsc-metadata-key">
                        <small class="ot--has-text-muted" i18n>Created date</small>
                      </div>
                      <div class="ot-row__column otsc-metadata-value">
                        <p>{{currentDeploymentResult.createdDateTime | fromNow}}</p>
                      </div>
                    </div>
                    <div class="ot-row" data-activity-metadata-row="last-updated">
                      <div class="ot-row__column otsc-metadata-key">
                        <small class="ot--has-text-muted" i18n>Last updated</small>
                      </div>
                      <div class="ot-row__column otsc-metadata-value">
                        <p>{{currentDeploymentResult.updatedDateTime | fromNow}}</p>
                      </div>
                    </div>
                    <div class="ot-row" data-activity-metadata-row="current-status">
                      <div class="ot-row__column otsc-metadata-key">
                        <small class="ot--has-text-muted" i18n>Current status</small>
                      </div>
                      <div class="ot-row__column otsc-metadata-value">
                        <p>{{this.getDeploymentStatusMessage(currentDeploymentResult)}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (activePropertyTab === ActivityExecutionPropertyTab.STEPS) {
                <div id="otsc-activity-execution-steps" class="otsc-activities-section">
                  <div class="otsc-activities-section-title ot-pl-3 ot-pr-3" i18n>Steps</div>
                  <div class="ot-pt-1 ot-pb-1 ot-pl-3 ot-pr-3 step-containter">
                    <app-datatable [identifier]="'activities-execution-steps-table'" [cols]="deploymentStepsCol" [rows]="deploymentStepsRow" (actionmenuevent)="deploymentStepActionMenuClicked($event)" (rowclickevent)="deploymentStepRowlicked($event)"></app-datatable>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
</ng-template>